import React, { useState } from 'react';
import { Button, Select, Text } from '@vymo/ui/atoms';
import { Body, Footer, Header, Modal } from '@vymo/ui/blocks';
import styles from './index.module.scss';

interface SandboxDialogProps {
  onSelect: (appId: string, portalId: string) => void;
  onClose: () => void;
}

const appsConfig = JSON.parse(process.env.APPS_CONFIG || '[]');

const appOptions = appsConfig.map((app: any) => ({
  label: app.title || app.name,
  value: app.name,
  clients: app.output?.clients || [],
}));

function SandboxDialog({ onSelect, onClose }: SandboxDialogProps) {
  const [selectedApp, setSelectedApp] = useState('');
  const [selectedClient, setSelectedClient] = useState('');

  const selectedAppConfig = appOptions.find((app) => app.value === selectedApp);
  const clientOptions =
    selectedAppConfig?.clients.map((client) => ({
      label: client,
      value: client,
    })) || [];

  const handleSubmit = () => {
    onSelect(selectedApp, selectedClient || selectedApp);
  };

  return (
    <Modal open onClose={onClose} classNames={styles.sandbox__modal}>
      <Header>
        <Text type="h4">Select App</Text>
      </Header>
      <Body>
        <div className={styles.container}>
          <Select
            placeholder="Select App"
            value={selectedApp ? [selectedApp] : []}
            onChange={(values) => {
              // @ts-ignore
              setSelectedApp(values[0]?.value || '');
              setSelectedClient('');
            }}
            options={appOptions}
            classNames={styles.select}
            search
          />
          {clientOptions.length > 0 && (
            <Select
              placeholder="Select Client"
              value={selectedClient ? [selectedClient] : []}
              // @ts-ignore
              onChange={(values) => setSelectedClient(values[0]?.value || '')}
              options={clientOptions}
              classNames={styles.select}
              search
            />
          )}
        </div>
      </Body>
      <Footer>
        <div className={styles.sandbox__modal__actions}>
          <Button type="text" onClick={onClose}>
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            disabled={
              !selectedApp || (clientOptions.length > 0 && !selectedClient)
            }
          >
            Open App
          </Button>
        </div>
      </Footer>
    </Modal>
  );
}

export default SandboxDialog;
